import {
  SET_LOGIN_SCREEN,
  SET_BUILDING_IS_LOADING,
  SET_BUILDING_NOT_LOADING,
  RESET_UI,
  SET_FEATURES,
} from './actiontypes';

export function resetUIAction() {
  return {
    type: RESET_UI,
  };
}

export function setLoginScreenAction(isLoginScreen) {
  return {
    type: SET_LOGIN_SCREEN,
    isLoginScreen,
  };
}

export function setBuildingLoading(buildingId) {
  return {
    type: SET_BUILDING_IS_LOADING,
    buildingId,
  };
}

export function setBuildingNotLoading(buildingId) {
  return {
    type: SET_BUILDING_NOT_LOADING,
    buildingId,
  };
}

export function setFeatures(features) {
  return {
    type: SET_FEATURES,
    features,
  };
}
